module.exports = __webpack_public_path__ + "static/media/showScore.2493f75b.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/static/audio/showScore.mp3
// module id = 524
// module chunks = 0